/* eslint-disable no-underscore-dangle */
const {
  PART_FILE_ORIGIN,
  WORK_ORIGIN,
  WORKCENTER_ORIGIN,
  PARTNER_ORIGIN,
  WWW_ORIGIN,
  API_ORIGIN,
  GET_ORIGIN,
  AUTH_ORIGIN,
  BASE_DOMAIN,
  MSTS_ONBOARDING,
  CREDIT_KEY_URL,
  GRAPHQL_ORIGIN,
  GRAPHQL_ENDPOINT,
  STATIC_ORIGIN,
  STRIPE_API_KEY,
  PROD_EXEMPTIONS,
  PAYMENT_FILE_ORIGIN,
  THOMAS_URL,
  THOMAS_AUTH_ENDPOINT_URL,
  AUTH0_CLIENT_ID,
  AUTH0_RESET_PASSWORD_URL,
  AUTH0_DB_CONNECTION,
  WORKATO_TEST_PART_URL,
  WORKATO_TOKEN,
  RFQ_ORIGIN,
  SENTRY_DSN,
  SENTRY_BASE_URL,
  FULLSTORY_DEV_MODE,
  FULLSTORY_ORG_ID,
  SMARTY_AUTOCOMPLETE,
  // this is a string but we want an array
  ALLOWED_REDIRECTS,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  STATSIG_CLIENT_KEY,
  STATSIG_ENV,
  // Coralogix configuration
  CORALOGIX_DOMAIN,
  CORALOGIX_API_KEY,
  BUILD_NUMBER,
  CI_COMMIT_SHA,
} = window.__env__ || {};

const convertedAllowedRedirects = (ALLOWED_REDIRECTS || '')
  .replaceAll(' ', '')
  .split(',');

export {
  PART_FILE_ORIGIN,
  WORK_ORIGIN,
  WORKCENTER_ORIGIN,
  PARTNER_ORIGIN,
  WWW_ORIGIN,
  API_ORIGIN,
  GET_ORIGIN,
  AUTH_ORIGIN,
  BASE_DOMAIN,
  MSTS_ONBOARDING,
  CREDIT_KEY_URL,
  GRAPHQL_ORIGIN,
  GRAPHQL_ENDPOINT,
  STATIC_ORIGIN,
  STRIPE_API_KEY,
  PROD_EXEMPTIONS,
  PAYMENT_FILE_ORIGIN,
  THOMAS_URL,
  THOMAS_AUTH_ENDPOINT_URL,
  AUTH0_CLIENT_ID,
  AUTH0_RESET_PASSWORD_URL,
  AUTH0_DB_CONNECTION,
  WORKATO_TEST_PART_URL,
  WORKATO_TOKEN,
  RFQ_ORIGIN,
  SENTRY_DSN,
  SENTRY_BASE_URL,
  FULLSTORY_DEV_MODE,
  FULLSTORY_ORG_ID,
  SMARTY_AUTOCOMPLETE,
  convertedAllowedRedirects as ALLOWED_REDIRECTS,
  STATSIG_CLIENT_KEY,
  STATSIG_ENV,
  CORALOGIX_DOMAIN,
  CORALOGIX_API_KEY,
  BUILD_NUMBER,
  CI_COMMIT_SHA,
};
